import { WindowDimensionsProvider } from '../../layout/components/WindowDimensionsProvider';
export default WindowDimensionsProvider;